/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListTicketCategory } from '../models/api-response-list-ticket-category';
import { ApiResponsePageTicketCategory } from '../models/api-response-page-ticket-category';
import { ApiResponseTicketCategory } from '../models/api-response-ticket-category';
import { create1 } from '../fn/ticket-category-api/create-1';
import { Create1$Params } from '../fn/ticket-category-api/create-1';
import { getAll1 } from '../fn/ticket-category-api/get-all-1';
import { GetAll1$Params } from '../fn/ticket-category-api/get-all-1';
import { getByRef } from '../fn/ticket-category-api/get-by-ref';
import { GetByRef$Params } from '../fn/ticket-category-api/get-by-ref';
import { search } from '../fn/ticket-category-api/search';
import { Search$Params } from '../fn/ticket-category-api/search';
import { update1 } from '../fn/ticket-category-api/update-1';
import { Update1$Params } from '../fn/ticket-category-api/update-1';

@Injectable({ providedIn: 'root' })
export class TicketCategoryApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `update1()` */
  static readonly Update1Path = '/v1/api/ui/category-ticket/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update1$Response(params: Update1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketCategory>> {
    return update1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update1(params: Update1$Params, context?: HttpContext): Observable<ApiResponseTicketCategory> {
    return this.update1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketCategory>): ApiResponseTicketCategory => r.body)
    );
  }

  /** Path part for operation `search()` */
  static readonly SearchPath = '/v1/api/ui/category-ticket/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `search()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  search$Response(params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageTicketCategory>> {
    return search(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `search$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  search(params: Search$Params, context?: HttpContext): Observable<ApiResponsePageTicketCategory> {
    return this.search$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePageTicketCategory>): ApiResponsePageTicketCategory => r.body)
    );
  }

  /** Path part for operation `create1()` */
  static readonly Create1Path = '/v1/api/ui/category-ticket/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create1$Response(params: Create1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketCategory>> {
    return create1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create1(params: Create1$Params, context?: HttpContext): Observable<ApiResponseTicketCategory> {
    return this.create1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketCategory>): ApiResponseTicketCategory => r.body)
    );
  }

  /** Path part for operation `getByRef()` */
  static readonly GetByRefPath = '/v1/api/ui/category-ticket/get/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRef$Response(params: GetByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketCategory>> {
    return getByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByRef(params: GetByRef$Params, context?: HttpContext): Observable<ApiResponseTicketCategory> {
    return this.getByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketCategory>): ApiResponseTicketCategory => r.body)
    );
  }

  /** Path part for operation `getAll1()` */
  static readonly GetAll1Path = '/v1/api/ui/category-ticket/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAll1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll1$Response(params?: GetAll1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketCategory>> {
    return getAll1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAll1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll1(params?: GetAll1$Params, context?: HttpContext): Observable<ApiResponseListTicketCategory> {
    return this.getAll1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTicketCategory>): ApiResponseListTicketCategory => r.body)
    );
  }

}
